<template>
  <div class="step-section-1">
    <el-col :span="23" :offset="1" style="position: relative">
      <div class="step1-bk-lable">
        <el-button type="primary" style="color: #000;" size="small" plain>本科</el-button>
      </div>
      <div
        style="
          margin: 20px 0;
          /* border-bottom: 1px solid #000; */
          padding-bottom: 10px;
          border-radius: 8px;
        "
      >
      <el-row>

        <!-- <el-col :span="24">
          <div style="margin-top: 5px;margin-left: 10px;margin-bottom: 10px;">
            <span style="font-size: 12px;">排序检索：</span>
    <el-radio-group v-model="bk_za_sort"  size="mini">
      
      <el-radio-button disabled v-for="(item,index) in az_sort_arr" :key="index" :label="item"></el-radio-button>
     
    </el-radio-group>
  </div>
      </el-col> -->
      </el-row>
      <!-- <el-col :span="24" style="font-size: 12px;margin-left: 10px;padding: 10px 0;">学校本科毕业生专业如下：</el-col> -->
       <el-row>
        <!-- 按学院分   xy_bk_zy_obj -->
            <el-col :span="24">
              <!-- 学院容器 -->
             <el-row style="font-size: 12px;border: 1px solid #000;"  v-for="(item,index) in xy_bk_zy_obj">
              <!-- 学院名称 -->
              <el-col :span="5" style="font-size: 14px;line-height: 38px;text-align: center;">{{item.xy}}</el-col>
              <el-col :span="19" style="border-left: 2px solid #000;">
                <el-row>
                   <el-checkbox-group v-model="checkboxGroupBenke" size="small">
                  <el-col :span="4"  v-for="(item1,index) in item.zy_arr">
                    <el-checkbox :label="item1" border style="margin-left: 10px;margin-top: 6px;"></el-checkbox>
                  </el-col>
              
                  
         <!-- <el-checkbox style="position: relative;display: block;width: 268px;" label="不限制专业" border>
            <el-col :span="24" style="position: absolute;bottom: 7px;font-size: 12px;">不确定专业岗位请选择该选项：不限制专业</el-col>
          </el-checkbox> -->
        </el-checkbox-group>
              </el-row>
        
            </el-col>
             
            </el-row>
              
            </el-col>
          </el-row> 
      
      <!-- <el-checkbox-group v-model="checkboxGroupBenke" size="small"> -->
         
          <!-- <el-checkbox
            :label="item"
            border
            style="margin-left: 10px;margin-top: 6px;"
            v-for="(item,index) in bk_zy_arr"
            :key="index"
          ></el-checkbox> -->
         
          <!-- <el-checkbox style="position: relative;display: block;width: 268px;" label="不限制专业" border>
            <el-col :span="24" style="position: absolute;bottom: 7px;font-size: 12px;">不确定专业岗位请选择该选项：不限制专业</el-col>
          </el-checkbox>
        </el-checkbox-group> -->
        
      </div>
    </el-col>
    <el-col :span="23" :offset="1" style="position: relative" v-if="true">
      <div class="step1-ss-lable">
        <el-button type="primary" style="color: blue;" size="small" plain>硕士</el-button>
      </div>
      <div
        style="
          margin: 0 0 20px 0;
          /* border: 1px solid #409eff; */
          padding: 10px;
          border-radius: 8px;
        "
      >
        <!-- <el-input
          type="textarea"
          :rows="12"
          placeholder="如果贵单位有硕士招聘需求，请将相关专业及人数在此处输入，例如：内科学20人，外科学10人"
          v-model="inputShuoshitextarea">
        </el-input> -->
        <el-row>

<el-col :span="24">
  <!-- <div style="margin-top: 5px;margin-left: 10px;margin-bottom: 10px;"> -->
    <!-- <span style="font-size: 12px;">排序检索：</span> -->
<!-- <el-radio-group v-model="bk_za_sort"  size="mini">

<el-radio-button disabled v-for="(item,index) in az_sort_arr" :key="index" :label="item"></el-radio-button>

</el-radio-group> -->
<!-- </div> -->
</el-col>
</el-row>
        <!-- 按学院分   xy_bk_zy_obj -->
            <el-col :span="24">
              <!-- 学院容器 -->
             <el-row style="font-size: 12px;border: 1px solid blue;"  v-for="(item,index) in xy_ss_zy_obj">
              <!-- 学院名称 -->
              <el-col :span="5" style="font-size: 14px;line-height: 38px;text-align: center;">{{item.xy}}</el-col>
              <el-col :span="19" style="border-left: 2px solid blue;">
                <el-row>
                   <el-checkbox-group v-model="checkboxGroupShuoshi" size="small">
                  <el-col :span="4"  v-for="(item1,index) in item.zy_arr">
                    <el-checkbox :label="item1" border style="margin-left: 10px;margin-top: 6px;"></el-checkbox>
                  </el-col>
              
                  
         <!-- <el-checkbox style="position: relative;display: block;width: 268px;" label="不限制专业" border>
            <el-col :span="24" style="position: absolute;bottom: 7px;font-size: 12px;">不确定专业岗位请选择该选项：不限制专业</el-col>
          </el-checkbox> -->
        </el-checkbox-group>
              </el-row>
        
            </el-col>
             
            </el-row>
              
            </el-col>

<!-- <el-col :span="24" style="font-size: 12px;margin-left: 10px;">学校硕士毕业生专业如下：</el-col> -->
        <!-- <el-checkbox-group v-model="checkboxGroupShuoshi" size="small" v-if="true">
          <el-checkbox
            :label="item"
            border
            style="margin-left: 10px;margin-top: 6px;"
            v-for="(item,index) in ss_zy_arr"
            :key="index"
          ></el-checkbox>
         
          <el-checkbox style="position: relative;display: block;width: 268px;" label="不限制专业" border>
            <el-col :span="24" style="position: absolute;bottom: 7px;font-size: 12px;">不确定专业岗位请选择该选项：不限制专业</el-col>
          </el-checkbox>
        </el-checkbox-group> -->
      </div>
    </el-col>

<!-- 博士 -->
 <el-col :span="23" :offset="1" style="position: relative" v-if="false">
      <div class="step1-ss-lable">
        <el-button type="primary" style="color: goldenrod;" size="small" plain>博士</el-button>
      </div>
      <div
        style="
          margin: 0 0 20px 0;
          padding: 10px;
          border-radius: 8px;
        "
      >

        <el-row>

<el-col :span="24">
</el-col>
</el-row>
        <!-- 按学院分   xy_ba_zy_obj -->
            <el-col :span="24">
              <!-- 学院容器 -->
             <el-row style="font-size: 12px;border: 1px solid goldenrod;"  v-for="(item,index) in xy_bs_zy_obj">
              <!-- 学院名称 -->
              <el-col :span="5" style="font-size: 14px;line-height: 38px;text-align: center;">{{item.xy}}</el-col>
              <el-col :span="19" style="border-left: 2px solid goldenrod;">
                <el-row>
                   <el-checkbox-group v-model="checkboxGroupBoshi" size="small">
                  <el-col :span="4"  v-for="(item1,index) in item.zy_arr">
                    <el-checkbox :label="item1" border style="margin-left: 10px;margin-top: 6px;"></el-checkbox>
                  </el-col>
            
        </el-checkbox-group>
              </el-row>
        
            </el-col>
             
            </el-row>
            </el-col>
      </div>
    </el-col>



  </div>
</template>

<script>
export default {
  name: "StepSection1",
  props: {
    stepOneData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      bk_za_sort:'全部专业',
      bk_zy_arr:["基础医学","医学实验技术","眼视光医学","临床医学","健康服务与管理","康复治疗学","药学","药物制剂","临床药学","中药学","食品科学与工程","食品质量与安全","预防医学","食品卫生与营养学","卫生检验与检疫","助产学","护理学","医学检验技术","医学影像学","医学影像技术","智能影像工程","口腔医学","麻醉学","儿科学","法医学","生物技术","生物医学工程","医学信息工程","数据科学与大数据技术","智能医学工程","化学生物学","社会体育指导与管理","休闲体育","运动康复","英语","药事管理","市场营销","教育技术学","公共事业管理","法学","应用心理学","思想政治与教育"],
      xy_bk_zy_obj:[
        {'xy':'基础医学院','zy_arr':["基础医学","医学实验技术"]},
        {'xy':'临床医学院','zy_arr':["眼视光医学","临床医学","健康服务与管理","康复治疗学"]},
        {'xy':'药学院','zy_arr':["药学","药物制剂","临床药学","中药学"]},
        {'xy':'公共卫生与健康学院','zy_arr':["食品科学与工程","食品质量与安全","预防医学","食品卫生与营养学","卫生检验与检疫"]},
        {'xy':'护理学院','zy_arr':["助产学","护理学",]},
        {'xy':'医学检验学院','zy_arr':["医学检验技术"]},
        {'xy':'医学影像学院','zy_arr':["医学影像学","医学影像技术","智能影像工程"]},
        {'xy':'口腔医学院','zy_arr':["口腔医学"]},
        {'xy':'麻醉学院','zy_arr':["麻醉学"]},
        {'xy':'儿科学院','zy_arr':["儿科学"]},
        {'xy':'法医学院','zy_arr':["法医学"]},
        {'xy':'生物与工程学院（健康医药现代产业学院）','zy_arr':["生物技术","生物医学工程","医学信息工程","数据科学与大数据技术","智能医学工程","化学生物学"]},
        {'xy':'运动与健康学院','zy_arr':["社会体育指导与管理","休闲体育","运动康复"]},
        {'xy':'外国语学院','zy_arr':["英语"]},
        {'xy':'医药卫生管理学院','zy_arr':["药事管理","市场营销","教育技术学","公共事业管理"]},
        {'xy':'医学人文学院','zy_arr':["法学","应用心理学"]},
        {'xy':'马克思主义学院','zy_arr':["思想政治教育"]},
        {'xy':'不限制专业','zy_arr':["不确定专业岗位请选择该选项：不限制专业"]}
    ],
    xy_ss_zy_obj:[
        {'xy':'法医学院','zy_arr':["法医学"]},
        {'xy':'公共卫生与健康学院','zy_arr':["公共卫生","公共卫生与预防医学","流行病与卫生统计学"]},
        {'xy':'护理学院','zy_arr':["护理","护理学"]},
        {'xy':'基础医学院','zy_arr':["病理学与病理生理学(基础医学)","病原生物学","动物学","免疫学","人体解剖与组织胚胎学","生理学","生物化学与分子生物学","细胞生物学","药理学"]},
        {'xy':'口腔医学院','zy_arr':["口腔临床医学","口腔医学",]},
        {'xy':'临床医学院','zy_arr':["病理学与病理生理学(临床医学)","儿科学","儿外科学","耳鼻咽喉科学","妇产科学","骨科学","急诊医学","精神病与精神卫生学","康复医学与理疗学","老年医学","临床病理","内科学","皮肤病与性病学","全科医学","神经病学","外科学","眼科学","运动医学","中西医结合","肿瘤学","重症医学"]},
        {'xy':'麻醉学院','zy_arr':["麻醉学"]},
        {'xy':'生物与工程学院','zy_arr':["生物与医药","生物医学工程","智能医学"]},
        {'xy':'药学院','zy_arr':["临床药学","生药学","微生物与生化药学","药剂学","药物分析学","药物化学","药学"]},
        {'xy':'医学检验学院','zy_arr':["临床检验诊断学"]},
        {'xy':'医学人文学院','zy_arr':["应用心理"]},
        {'xy':'医学影像学院','zy_arr':["超声医学","放射医学","放射影像学","核医学","影像医学与核医学"]},
        {'xy':'医药卫生管理学院','zy_arr':["公共管理"]},
        {'xy':'运动与健康学院','zy_arr':["社会体育指导","竞赛组织","体育教学","运动训练"]},
        {'xy':'博士研究生','zy_arr':["公共卫生与健康学院_博士研究生","基础医学院_博士研究生","临床医学院_博士研究生","药学院_博士研究生"]},
        {'xy':'不限制专业','zy_arr':["不确定专业岗位请选择该选项：不限制专业"]}
      ],
      xy_bs_zy_obj:[
        {'xy':'公共卫生与健康学院','zy_arr':["博士研究生"]},
        {'xy':'基础医学院','zy_arr':["博士研究生"]},
        {'xy':'临床医学院','zy_arr':["博士研究生"]},
        {'xy':'药学院','zy_arr':["博士研究生"]},
        {'xy':'不限制专业','zy_arr':["不确定专业岗位请选择该选项：不限制专业"]}
      ],
      ss_zy_arr:["法医学","公共卫生","公共卫生与预防医学","流行病与卫生统计学","护理","护理学","病理学与病理生理学(基础医学)","病原生物学","动物学","免疫学","人体解剖与组织胚胎学","生理学","生物化学与分子生物学","细胞生物学","药理学","口腔临床医学","口腔医学","病理学与病理生理学(临床医学)","儿科学","儿外科学","耳鼻咽喉科学","妇产科学","骨科学","急诊医学","精神病与精神卫生学","康复医学与理疗学","老年医学","临床病理","内科学","皮肤病与性病学","全科医学","神经病学","外科学","眼科学","运动医学","中西医结合","肿瘤学","重症医学","麻醉学","生物医学工程","临床药学","生药学","微生物与生化药学","药剂学","药物分析学","药物化学","药学","临床检验诊断学","应用心理","超声医学","放射医学","放射影像学","核医学","影像医学与核医学","公共管理","社会体育指导","竞赛组织","体育教学","运动训练"],
     
     
     
      // az_sort_arr:["全部专业","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
      az_sort_arr:["全部专业","A","--->","Z"],
      checkboxGroupBenke: [],
      checkboxGroupShuoshi: [],
      checkboxGroupBoshi:[],
      inputShuoshitextarea:'',
    };
  },
  mounted() {
    this.checkboxGroupBenke = this.stepOneData.checkBoxGroupBenke;
    this.checkboxGroupShuoshi = this.stepOneData.checkBoxGroupShuoshi;
    this.checkboxGroupBoshi = this.stepOneData.checkboxGroupBoshi;
    this.inputShuoshitextarea = this.stepOneData.inputShuoshitextarea;
    this.sortAz(this.bk_zy_arr);
    this.sortAz(this.ss_zy_arr);
  },
  methods: {
    sortAz(za_arr){
      let sortArray = za_arr.sort(function (str1, str2) {
        return str1.localeCompare(str2, 'zh');
      });
      console.log(sortArray)
    }
  }
};
</script>

<style scoped>
.el-checkbox.is-bordered.el-checkbox--small {
  padding: 5px 15px 5px 10px;
  border-radius: 3px;
  height: 30px;
  margin-top: 6px;
}
.el-checkbox {
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-right: 8px;
}
.step1-bk-lable {
  position: absolute;
  left: -60px;
  top: 110px;
}
.step1-ss-lable {
  position: absolute;
  left: -60px;
  top: 180px;
}
</style>



// WEBPACK FOOTER //
// src/project/add-section/stepSection1.vue